import CityPageTemplate from "../city-template/CityPageTemplate";
import { topshamConfig } from "./data";

export default function TopshamPage() {
  return <CityPageTemplate config={topshamConfig} />;
}